export const freeTrialQrCode = "/demo_qr_code";
